import React from 'react';
import questionareStyle from '../../style';
import YesNo from '../YesNo';

export default function Slide4(props){
    let style = questionareStyle();

    return(
        <div>
            <p
             style={{
                ...{
                    marginTop: '1rem'
                },
                ...style.questionareText()
             }}
            >
                Do you have trouble making it to the gym? but still, wanting to work out at home or elsewhere?
            </p>
            <YesNo 
                nextPressed = {(answer) => {
                    props.nextPressed({
                        a4: answer
                    });
                }}
            />
        </div>
    );
}